import { Component, Inject, Input, OnDestroy, OnInit, AfterViewInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NewhomepageService } from '../newhomepage.service';
import { Subscription } from 'rxjs';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { CommonModule, DOCUMENT, isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { TalkToSalesButtonComponent } from 'src/app/shared/components/talktosalesButton/talktosalesButton.component';
import { CommonBorderlessComponent } from 'src/app/shared/components/borderless/borderless.component';
import { CommonLatestNewsComponent } from 'src/app/shared/components/latest-news/latest-news.component';
import { PosthogService } from 'src/app/shared/services/posthog.service';

import { ActivatedRoute } from '@angular/router';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { TrustPilotComponent } from 'src/app/shared/components/trust-pilot/trust-pilot.component';
@Component({
  selector: 'app-newheroheader',
  templateUrl: './newheroheader.component.html',
  styleUrls: ['./newheroheader.component.scss'],
  imports: [
    CommonModule,
    ToHtmlPipe,
    TalkToSalesButtonComponent,
    NgOptimizedImage,
    CommonBorderlessComponent,
    CommonLatestNewsComponent,
    UrlParamsPipe,
    TrustPilotComponent
  ],
  encapsulation: ViewEncapsulation.None,
})
export class NewheroheaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() pageData: any;
  @Input() getStartedDesign: any;
  @Input() highlightedText: any;
  subscriptions: Subscription[] = [];
  backgroundImageUrl: string = '';
  containerId = '.image-container';
  whiteTitle: string = '';
  coloredTitle: string = '';
  isMobileView: boolean = false;
  imageSrc: string = '';
  trustedWaySectionData: any;
  unifiedSolutionsData: any;
  financialSolData: any;
  regulated: any;
  discoverPanelData: any;
  security: any;
  startPanel: any;
  blogData: any;
  borderlessData: any;
  getWay: any;
  protocol = 'https:';
  highlightedTextUnified: any;
  queryParams: any;
  private testimonialObserver: IntersectionObserver | null = null;
  private viewedTestimonials: Set<string> = new Set();
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private homePageService: NewhomepageService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private posthog: PosthogService
  ) {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  private scrollToFragment(fragment: string, retries = 15): void {
    if (!isPlatformBrowser(this.platformId)) return;
    
    // Remove trailing slash if present
    const cleanFragment = fragment.replace(/\/$/, '');
    const element = this.document.getElementById(cleanFragment);
    if (element) {
      // Instant scroll to get close to the target
      element.scrollIntoView({ behavior: 'auto', block: 'start' });
      
      // Final smooth correction after lazy content settles
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 800);
    } else if (retries > 0) {
      // Retry since deferred content may not be rendered yet
      setTimeout(() => this.scrollToFragment(cleanFragment, retries - 1), 200);
    }
  }

  ngOnInit(): void {
    this.getStartedDesign = this.pageData?.psHeroPanel?.[0]?.fields;
    
    // Only load Trustpilot script in browser environment
    if (
      this.getStartedDesign?.title?.includes(
        'Cross Border payments infrastructure'
      )
    ) {
      this.whiteTitle = this.getStartedDesign.title.replace(
        /Cross Border payments infrastructure/g,
        ''
      );
      this.coloredTitle = 'Cross Border payments infrastructure';
    }
    
    this.imageSrc = this.getStartedDesign?.image?.[0]?.fields?.file?.url;

    const data = this.pageData?.psCustomerStatsContentPanel.fields;
    this.borderlessData = this.pageData?.psMobileAppGetStartedPanel?.fields;
    this.blogData = this.pageData?.psBlogPanel?.[0]?.fields;
    if (data) {
      this.trustedWaySectionData = {
        header: data.title,
        description: data.content.content[0].content[0].value,
        testimonials: data.components,
      };
    }

    const udata = this.pageData?.psProductSuite.fields;
    if (udata != null) {
      this.unifiedSolutionsData = {
        header: udata?.title || '',
        cards: udata?.component1 || [],
        description: udata?.content.content[0].content[0].value,
      };
      this.highlightedTextUnified = this.unifiedSolutionsData?.header.replace(
        /Unified solutions/g,
        '<span class="pink-800">Unified solutions</span>'
      );
    }

    const fdata = this.pageData?.psCompanySizePanel?.fields;
    if (fdata != null) {
      this.financialSolData = {
        header: fdata?.title,
        title: fdata?.component1,
      };
    }

    const rdata = this.pageData?.psLicensesPanel?.fields;
    if (rdata != null) {
      this.regulated = rdata;
    }

    const tdata = this.pageData?.psCustomerStories?.fields;
    if (tdata != null) {
      this.discoverPanelData = tdata;
      this.discoverPanelData.components[0].active = true;
      this.discoverPanelData = {
        title: tdata.title,
        components: tdata?.components,
        image: tdata?.image[0]?.fields?.file?.url,
      };
    }

    const sdata = this.pageData?.psSecurityPanel?.fields;
    if (sdata != null) {
      this.security = sdata;
    }
    const ddata = this.pageData?.psGetStartedPanel?.fields;
    if (ddata != null) {
      this.startPanel = ddata;
      this.highlightedText = this.startPanel.title.replace(
        /Verto/g,
        '<span class="highlight">Verto</span>'
      );
    }
    const gdata = this.pageData?.psValuePropPanel2?.fields;
    if (gdata != null) {
      this.getWay = gdata;
    }
    // Browser-specific logic
    if (isPlatformBrowser(this.platformId)) {
      if (window.outerWidth < 768) {
        this.imageSrc = this.getStartedDesign?.image?.[1]?.fields?.file?.url;
      }
    }
  }
  
  ngAfterViewInit(): void {
    // Setup Intersection Observer for testimonial section
    if (isPlatformBrowser(this.platformId) && this.discoverPanelData) {
      this.setupTestimonialObserver();
    }

    // Handle fragment scrolling for deferred content
    if (isPlatformBrowser(this.platformId)) {
      // Check for hash on initial page load
      const hash = window.location.hash;
      if (hash) {
        const fragment = hash.substring(1); // Remove leading #
        setTimeout(() => this.scrollToFragment(fragment), 300);
      }

      // Also subscribe to route fragment changes for SPA navigation
      this.subscriptions.push(
        this.route.fragment.subscribe(fragment => {
          if (fragment) {
            setTimeout(() => this.scrollToFragment(fragment), 300);
          }
        })
      );
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
    // Clean up Intersection Observer
    if (this.testimonialObserver) {
      this.testimonialObserver.disconnect();
    }
  }

  private setupTestimonialObserver(): void {
    const testimonialSection = this.document.querySelector('.tabs-light');
    if (!testimonialSection) return;

    this.testimonialObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            // Track view for active testimonial
            const activeTab = this.discoverPanelData.components.find((t: any) => t.active);
            if (activeTab) {
              const companyName = activeTab.fields.title;
              const position = this.discoverPanelData.components.indexOf(activeTab) + 1;
              const key = `${companyName}_${position}`;
              
              if (!this.viewedTestimonials.has(key)) {
                this.viewedTestimonials.add(key);
                this.posthog.captureTestimonialView(companyName, position);
              }
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    this.testimonialObserver.observe(testimonialSection);
  }

  selectTab(event: any) {
    // Track tab click
    const companyName = event.fields.title;
    const position = this.discoverPanelData.components.indexOf(event) + 1;
    this.posthog.captureTestimonialTabClick(companyName, position);

    // Update active tab
    this.discoverPanelData.components.forEach((tab:any) => {
      tab.active = tab.fields.title === event.fields.title;
    });
  }
  openRegisterLink(event:any, target?:string) {
    event.preventDefault();
    const link = event.target.attributes.href.value;
    const searchParams = location.search !== '' ? location.search.slice(1) : '';
    let linkHasParams = new URLSearchParams(link) as any;
    let url = link;
    if(searchParams !== ''){
      if(linkHasParams.search > 0){
        url = `${link}&${searchParams}`;
      }else{
        url = `${link}?${searchParams}`;
      }
    }
    window.open(url, target || '_blank');
  }
  openLink(event:any, target?:string) {
    event.preventDefault();
    const link = event.target.attributes.href.value;
    const searchParams = location.search !== '' ? location.search.slice(1) : '';
    let linkHasParams = new URLSearchParams(link) as any;
    let url = link;
    if(searchParams !== ''){
      if(linkHasParams.search > 0){
        url = `${link}&${searchParams}`;
      }else{
        url = `${link}?${searchParams}`;
      }
    }
    window.open(url, target || '_self');
  }

  onHomepageHeroCTAClick(): void {
    const action = this.getStartedDesign?.buttons?.[0].fields.buttonText?.toLowerCase().replace(/\s+/g, '_') || 'get_started';
    this.posthog.captureCTAClick(action, 'hero', {
      ctaText: this.getStartedDesign?.buttons?.[0].fields.buttonText,
      destinationUrl: this.getStartedDesign?.buttons?.[0].fields.redirectLink
    });
  }

  onStartPanelCTAClick(): void {
    const action = this.startPanel?.buttons?.[0].fields.buttonText?.toLowerCase().replace(/\s+/g, '_') || 'get_started';
    this.posthog.captureCTAClick(action, 'bottom', {
      ctaText: this.startPanel?.buttons?.[0].fields.buttonText,
      destinationUrl: this.startPanel?.buttons?.[0].fields.redirectLink
    });
  }

  onUnifiedSolutionsCardClick(cardTitle: string, destinationUrl: string): void {
    // Determine card type based on destination URL
    const cardType = destinationUrl?.includes('/solutions/') ? 'solution' : 'product';
    const currentUrl = isPlatformBrowser(this.platformId) && typeof window !== 'undefined' 
      ? window.location.pathname 
      : '';
    const pageName = currentUrl.split('/').filter(s => s).pop() || 'home';
    
    this.posthog.captureCardClick(cardTitle, cardType, pageName, {
      destinationUrl: destinationUrl
    });
  }

  onTestimonialCaseStudyClick(companyName: string, destinationUrl: string): void {
    const position = this.discoverPanelData.components.findIndex((t: any) => t.fields.title === companyName) + 1;
    this.posthog.captureTestimonialCaseStudyClick(companyName, position, {
      destinationUrl: destinationUrl
    });
  }
}
